import React, { useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useReadCookies from "../../hooks/useReadCookies";

function MainQuestionEnd ({missionSuccess}) {

  const { t } = useTranslation();

  let messageRef = useRef(null);

  let {cookiePlayerId} = useReadCookies();

  const players = useSelector((state) => state.game.players);
  const [mainQuestionPlayer, setMainQuestionPlayer] = useState(null);

  const otherPlayerName = players.reduce((filtered, player) => {
    if(player.secret !== cookiePlayerId){
      filtered.push(player.name);
    }
    return filtered;
  }, []);

  return (
    <div className="main-question-end-wrapper">
      <div className="main-question-end" ref={messageRef}>
        <div className="message-box-wrapper"  >
          <div className={`icon ${missionSuccess ? 'success' : 'fail'}`}>
            <div className="collectable"></div>
          </div>
          <h3 className="title">
            {missionSuccess && t("student.main_question.sucess_title")}
            {!missionSuccess && t("student.main_question.failed_title")}
          </h3>
          <p className="details">
            {missionSuccess && t("student.main_question.sucess_message")}
            {!missionSuccess && t("student.main_question.failed_message", otherPlayerName)}
          </p>
        </div>
      </div>
      <div className={`resultVisual ${missionSuccess ? 'success' : 'fail'}`}></div>
    </div>
  );
}

export default MainQuestionEnd;